export default {
  baseUrl: process.env.REACT_APP_LINK_BASE_URL || ''
}
